export enum ACTIONS {
  SUPPORT = 'SUPPORT',
  ACCOUNT = 'ACCOUNT',
  MOBILE_MENU = 'MOBILE_MENU',
  NOTIFICATION = 'NOTIFICATION',
  CLOSE = 'CLOSE',
}

type TReducerState = {
  isDropdownOpen: boolean;
  selectedDropdown: ACTIONS;
};

type TReducerAction = {
  type: ACTIONS;
};

export const initialReducerState = {
  isDropdownOpen: false,
  selectedDropdown: ACTIONS.CLOSE,
};

// Generic debouncer to prevent constant re-render
export const dropdownReducer = (
  state: TReducerState,
  action: TReducerAction,
) => {
  switch (action.type) {
    case ACTIONS.ACCOUNT:
    case ACTIONS.SUPPORT:
    case ACTIONS.MOBILE_MENU:
    case ACTIONS.NOTIFICATION:
      return {
        isDropdownOpen: true,
        selectedDropdown: action.type,
      };
    case ACTIONS.CLOSE:
    default:
      return {
        ...state,
        isDropdownOpen: false,
      };
  }
};
